import React from 'react';
import { Phone, MapPin, Clock, Mail } from 'lucide-react';
import { businessInfo } from '../data/mock';

export const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
      {/* Background Grid */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(139, 92, 246, 0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(139, 92, 246, 0.3) 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Kontakta <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">Oss</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto mb-8">
            Ring oss direkt så hjälper vi dig med din bil
          </p>
          
          {/* Main CTA */}
          <a 
            href={`tel:${businessInfo.phone}`}
            className="inline-flex items-center gap-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-12 py-6 rounded-2xl font-bold text-2xl hover:from-purple-700 hover:to-pink-700 transition-all duration-300 shadow-2xl shadow-purple-500/50 hover:shadow-purple-500/70 hover:scale-105"
          >
            <Phone size={32} className="animate-pulse" />
            {businessInfo.phone}
          </a>

          {/* Email Option */}
          <p className="text-gray-400 text-lg mt-4">
            eller mejla oss på{' '}
            <a 
              href={`mailto:${businessInfo.email}`}
              className="text-purple-400 hover:text-pink-400 font-semibold underline transition-colors duration-300"
            >
              {businessInfo.email}
            </a>
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {/* Phone Card */}
          <div className="bg-gradient-to-br from-purple-600 to-pink-600 p-8 rounded-2xl text-center hover:shadow-2xl hover:shadow-purple-500/50 transition-all duration-300 hover:scale-105">
            <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
              <Phone size={32} className="text-white" />
            </div>
            <div className="text-white/80 text-sm font-medium mb-2">Ring Oss</div>
            <a href={`tel:${businessInfo.phone}`} className="text-white text-xl font-bold hover:underline">
              {businessInfo.phone}
            </a>
            <p className="text-white/70 text-sm mt-2">Vardagar 08–18</p>
          </div>

          {/* Email Card */}
          <div className="bg-gradient-to-br from-gray-800/80 to-gray-900/80 backdrop-blur-sm p-8 rounded-2xl border border-gray-700/50 text-center hover:border-purple-500/50 transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-purple-600/20 to-pink-600/20 rounded-xl flex items-center justify-center mx-auto mb-4">
              <Mail size={32} className="text-purple-400" />
            </div>
            <div className="text-gray-400 text-sm font-medium mb-2">E-post</div>
            <a href={`mailto:${businessInfo.email}`} className="text-white text-lg font-semibold hover:text-purple-400 transition-colors break-all">
              {businessInfo.email}
            </a>
          </div>

          {/* Address Card */}
          <div className="bg-gradient-to-br from-gray-800/80 to-gray-900/80 backdrop-blur-sm p-8 rounded-2xl border border-gray-700/50 text-center">
            <div className="w-16 h-16 bg-gradient-to-br from-purple-600/20 to-pink-600/20 rounded-xl flex items-center justify-center mx-auto mb-4">
              <MapPin size={32} className="text-purple-400" />
            </div>
            <div className="text-gray-400 text-sm font-medium mb-2">Adress</div>
            <div className="text-white text-lg font-semibold">{businessInfo.address.street}</div>
            <div className="text-gray-300">{businessInfo.address.postal}</div>
          </div>
        </div>

        {/* Map */}
        <div className="mt-12 max-w-5xl mx-auto rounded-2xl overflow-hidden border border-gray-700/50 h-96 shadow-2xl">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1819.5!2d17.1418309!3d60.6746161!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zw4RuZ3N1bGxzdsOkZ2VuIDI2LCA4MDYgMzYgR8Okdmxl!5e0!3m2!1ssv!2sse!4v1640000000000"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Gävles Autodepå Location"
          ></iframe>
        </div>

        {/* Bottom Message */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 text-lg">
            📞 Vi svarar snabbt! Ring oss idag för att boka tid eller få mer information.
          </p>
        </div>
      </div>
    </section>
  );
};
